import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function LegendaryStreakIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3790">
      <div className="relative w-full h-full bg-gradient-to-b from-purple-800 to-fuchsia-900 overflow-hidden" data-id="element-3791">
        {/* Background: Royal Hall / Throne Room */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3792">
          {/* Columns */}
          <rect x="20" y="0" width="20" height="200" fill="#4C1D95" data-id="element-3793" />
          <rect x="25" y="0" width="10" height="200" fill="#5B21B6" data-id="element-3794" />
          <rect x="160" y="0" width="20" height="200" fill="#4C1D95" data-id="element-3795" />
          <rect x="165" y="0" width="10" height="200" fill="#5B21B6" data-id="element-3796" />

          {/* Red Carpet */}
          <path d="M60 200 L140 200 L120 100 L80 100 Z" fill="#BE123C" data-id="element-3797" />
          <path d="M70 200 L130 200 L115 100 L85 100 Z" fill="#E11D48" data-id="element-3798" />
        </svg>

        {/* Throne behind Djay */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3799">
          <path d="M60 140 L60 60 Q100 30 140 60 L140 140 Z" fill="#F59E0B" data-id="element-3800" />
          <path d="M65 140 L65 65 Q100 40 135 65 L135 140 Z" fill="#FCD34D" data-id="element-3801" />
          <circle cx="100" cy="50" r="10" fill="#EF4444" data-id="element-3802" />
          <rect x="50" y="100" width="15" height="40" rx="4" fill="#D97706" data-id="element-3803" />
          <rect x="135" y="100" width="15" height="40" rx="4" fill="#D97706" data-id="element-3804" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[15%]" data-id="element-3805">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3806">
            <DjaySpecimen look={{
            variant,
            accessory: 'scepter'
          }} size="hero" emotion={isUnlocked ? 'proud' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3807" />
          </div>
        </div>

        {/* Foreground: Sparkles */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3808">
            <path d="M40 80 L42 90 L50 92 L42 94 L40 104 L38 94 L30 92 L38 90 Z" fill="#FDE047" data-id="element-3809" />
            <path d="M160 60 L161 65 L165 66 L161 67 L160 72 L159 67 L155 66 L159 65 Z" fill="#FDE047" data-id="element-3810" />
            <path d="M150 140 L152 148 L160 150 L152 152 L150 160 L148 152 L140 150 L148 148 Z" fill="#FDE047" data-id="element-3811" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}